/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback, useState } from 'react';

import CustomButton from '../../common/CustomButton/CustomButton';
import CustomLink from '../../common/CustomLink/CustomLink';
import StarRating from '../../common/StarRating/StarRating';
import { useUserContext } from '../../core/context/user.context';
import { slugify } from '../../core/helpers';
import useFetch from '../../core/hooks/useFetch';
import { setCookie } from '../../core/service';
import './AIFeedback.css';

interface IProps {
  ai: any;
  callback?: () => unknown;
}

const COOKIE_EXP = 30;
const BASE_URL = `${process.env.REACT_APP_API_URL}`;

function AIFeedback({ ai, callback }: IProps) {
  const { user } = useUserContext();
  const [rating, setRating] = useState<number | null>(null);
  const { doFetch, loading } = useFetch(`${BASE_URL}/ai_feedback/create`, true);

  const handleClick = useCallback(() => {
    setCookie(
      `feedback-${slugify(ai.appId || ai.assistantID || ai.title || '')}`,
      'true',
      COOKIE_EXP,
    );
    if (callback) callback();
  }, [callback, ai]);

  const submitFeedback = useCallback(async () => {
    const res = await doFetch({
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        rating,
        title: ai.title,
        page: window.location.href,
        user: user?.email || null,
        question: ai.feedback?.title || null,
      }),
    });
    if (res?.status === 'success') handleClick();
  }, [ai.feedback?.title, ai.title, doFetch, handleClick, rating, user?.email]);

  return (
    <div className="feedback">
      <h2 className="feedback__title h3">{ai.feedback?.title}</h2>
      {ai.feedback?.type === 'external' ? (
        !ai.feedback.cta ? null : (
          <CustomLink className="feedback__cta" link={ai.feedback.cta} onClick={handleClick} />
        )
      ) : (
        <>
          <StarRating rating={rating} setRating={setRating} stars={7} />
          <CustomButton
            disabled={!rating}
            loading={loading}
            className={`feedback__cta btn btn--${
              ai.feedback?.btnColor ? `${ai.feedback.btnColor}` : 'primary'
            }`}
            type="button"
            onClick={submitFeedback}
          >
            {ai.feedback?.btnText}
            <span className="sr-only">
              {rating} {rating === 1 ? 'star' : 'stars'}
            </span>
          </CustomButton>
        </>
      )}
    </div>
  );
}

export default AIFeedback;
